import { EllipsedText, FlexColumn, FlexRow, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { Cell, Grid } from 'baseui/layout-grid';
import { LabelMedium, LabelSmall, ParagraphSmall } from 'baseui/typography';
import { ASSET_TYPE, ASSET_TYPE_CONTAINER } from '../../constants/asset';
import { useStyles } from '../../hooks/useStyles';
import { Event, EventCore } from '../../types/gptTypes';
import { isVehicleKind } from '../../utils/assets';
import { getTimeByMinutes } from '../../utils/fields';
import ContainerData from '../shared/ContainerData';
import VehicleData from '../shared/VehicleData';

type Props = {
  event: EventCore | Event;
};

export function GptEventDetailData({ event }: Readonly<Props>) {
  const { theme, classes, css } = useStyles();
  const { formatDateFromTs } = useMoment();
  const labelWidth = '120px';

  const shortData = !('ignitionStatus' in event);

  const cs = shortData ? undefined : event.cs;

  return (
    <Block>
      <Grid
        gridColumns={12}
        gridGaps={[8]}
        gridGutters={[30]}
        gridMargins={[0]}
        behavior="fluid"
      >
        <Cell span={[12, 12, 12, 6, 6]}>
          <FlexColumn gap={0}>
            <LabelMedium
              className={classes.dataHeaderClass}
              marginBottom={theme.sizing.scale200}
            >
              Datos generales
            </LabelMedium>
            <LabeledData
              label={'Fecha detectado:'}
              content={formatDateFromTs(event.created)}
              labelWidth={labelWidth}
            />
            {shortData && (
              <LabeledData
                label={'Estado:'}
                content={event.statusDisplay || '-'}
                labelWidth={labelWidth}
                inline={false}
              />
            )}
            <LabeledData
              label={'Activo:'}
              content={event.asset?.label ?? '-'}
              labelWidth={labelWidth}
              inline={false}
            />
            {!shortData && (
              <LabeledData
                label={'Encendido:'}
                content={event.ignitionStatus ? 'Si' : 'No'}
                labelWidth={labelWidth}
                inline={false}
              />
            )}
            {!shortData && (
              <LabeledData
                label={'Manejo Continuo:'}
                content={event.continuousDriving ? getTimeByMinutes(event.continuousDriving) : '0min.'}
                labelWidth={labelWidth}
                inline={false}
              />
            )}
            <LabeledData
              label={'Cliente:'}
              content={event.asset?.client?.name ?? '-'}
              labelWidth={labelWidth}
              inline={false}
            />
            <LabeledData
              label={'Subcliente:'}
              content={event.asset?.subClient?.name ?? '-'}
              labelWidth={labelWidth}
              inline={false}
            />
            <LabeledData
              label={'Dispositivo:'}
              content={event.ident}
              labelWidth={labelWidth}
              inline={false}
            />
            <LabeledData
              label={'Tipo:'}
              content={event.asset?.assetType ? ASSET_TYPE[event.asset.assetType] : '-'}
              labelWidth={labelWidth}
              inline={false}
            />
          </FlexColumn>
        </Cell>
        <Cell span={[12, 12, 12, 6, 6]}>
          <FlexColumn gap={theme.sizing.scale300}>
            {event.asset?.assetType === ASSET_TYPE_CONTAINER && <ContainerData container={event.asset.container} />}
            {isVehicleKind(event.asset?.assetType) && <VehicleData vehicle={event.asset?.vehicle} />}
          </FlexColumn>
        </Cell>
        {!shortData && cs && (
          <Cell span={[12]}>
            <FlexRow
              gap={theme.sizing.scale300}
              classNames={css({
                alignItems: 'baseline',
              })}
            >
              <LabelSmall>{'Ultima posición:'}</LabelSmall>
              <ParagraphSmall
                margin={0}
                color={theme.colors.contentSecondary}
              >
                <EllipsedText inline>{cs.timestamp ? formatDateFromTs(cs.timestamp) : '-'}</EllipsedText>
              </ParagraphSmall>
              {!!cs.latitude && !!cs.longitude && (
                <>
                  <LabelSmall>{'Coordenadas:'}</LabelSmall>
                  <ParagraphSmall
                    margin={0}
                    color={theme.colors.contentSecondary}
                  >
                    <EllipsedText inline>
                      {`${cs.latitude},${cs.longitude} 
                          ${cs.engineIgnitionStatus ? 'Encendido' : 'Apagado'}
                          ${cs.speed}km/h`}
                    </EllipsedText>
                  </ParagraphSmall>
                </>
              )}
            </FlexRow>
          </Cell>
        )}
      </Grid>
    </Block>
  );
}
